import { useEffect, useRef, useState } from "react"
import { Alert, Button, Modal, Space, Table, Upload, message } from "antd"
import { Eye, Trash2 } from "lucide-react"
import { useRequest } from "ahooks"
import { deleteProjectHQNewTaskAttachmentApi, getProjectHQNewTaskAttachmentsApi, uploadProjectHQNewTaskAttachmentApi } from "@/services/apis/projectDesignHQNew"

export const AttachmentManager = ({ task, onClose }: { task: API.PROJECTHQ_NEW.Task; onClose: () => void }) => {
  const files = useRequest(getProjectHQNewTaskAttachmentsApi, { manual: true })
  const [uploading, setUploading] = useState(false)
  const [deleting, setDeleting] = useState<number | null>(null)
  const writing = useRef(false)
  useEffect(() => { files.run(task.id); return () => files.cancel() }, [task.id]) // eslint-disable-line react-hooks/exhaustive-deps
  const upload = async (file: File) => {
    if (writing.current) return
    writing.current = true; setUploading(true)
    try { await uploadProjectHQNewTaskAttachmentApi(task.id, file); message.success("上传成功"); files.run(task.id) }
    catch (error) { message.error(typeof error === "string" ? error : "附件上传失败") }
    finally { writing.current = false; setUploading(false) }
  }
  const remove = (file: API.PROJECTHQ_NEW.Attachment) => Modal.confirm({
    title: "确认删除", content: `确定删除“${file.filename}”？`,
    onOk: async () => {
      if (writing.current) return
      writing.current = true; setDeleting(file.id)
      try { await deleteProjectHQNewTaskAttachmentApi(file.id); message.success("文件删除成功"); files.run(task.id) }
      catch (error) { message.error(typeof error === "string" ? error : "附件删除失败"); throw error }
      finally { writing.current = false; setDeleting(null) }
    },
  })
  return <Modal open title={`DDS附件管理 · ${task.value}`} width={760} maskClosable={!uploading && deleting === null}
    closable={!uploading && deleting === null} onCancel={onClose} footer={<Button disabled={uploading || deleting !== null} onClick={onClose}>关闭</Button>}>
    <Upload showUploadList={false} disabled={uploading || deleting !== null} beforeUpload={file => { void upload(file); return false }}>
      <Button loading={uploading} disabled={uploading || deleting !== null}>{uploading ? "上传中..." : "上传DDS附件"}</Button>
    </Upload>
    {files.error && <Alert type="error" message="附件加载失败" action={<Button onClick={() => files.run(task.id)}>重试</Button>} />}
    <Table<API.PROJECTHQ_NEW.Attachment> className="mt-4" rowKey="id" pagination={false} dataSource={files.data || []} loading={files.loading}
      columns={[{ title: "文件名", dataIndex: "filename" }, { title: "操作", render: (_, file) => <Space>
        {file.ddsFilePath && <a aria-label={`预览${file.filename}`} href={file.ddsFilePath} target="_blank" rel="noopener noreferrer"><Eye size={16} /></a>}
        <Button aria-label={`删除${file.filename}`} type="text" danger loading={deleting === file.id} disabled={uploading || deleting !== null} onClick={() => remove(file)}><Trash2 size={16} /></Button>
      </Space> }]} />
  </Modal>
}
